import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import _ from 'lodash'
import { Button, Icon } from '@shopify/polaris'
import IconPlus from 'react-icons/lib/fa/plus-circle'

import * as scenes from 'templates/outSide/scenes'
import { getTemplateInfo } from 'templates/templates'
import { delSlide } from 'controllers/logic'
import { changeEditorScene } from 'actions/locationAC'
import Text from 'components/common/Text'
import { SHOPIFY_TEAL } from 'components/styles'

const Wrapper = styled.div`
  width: 40em;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 1200px;
`
const ScenesListWrapper = styled.div`
  _height: 100%;
  width: 100%;
  flex-grow: 10;
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(63, 63, 68, 0.15), 0 0 0 1px rgba(63, 63, 68, 0.05);
`
const FooterContainer = styled.div`
  flex-shrink: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  border-top: solid 0.5px #979797;
  margin-top: 5em;

  & > button {
    margin-top: 1em;
    margin-left: 1em;
  }
`
const Header = styled.div`
  height: 4em;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 1em;
  flex-shrink: 0;
  border-bottom: solid 1px #dfe3e8;
`
const AddSceneButton = styled.div`
  width: 100%;
  height: 4em;
  background-color: #f3f4fa;
  box-shadow: inset 0 -1px 0 0 #dfe3e8;
  display: flex;
  align-items: center;
  padding: 2em;
  cursor: pointer;
`
const SceneRow = styled.div`
  width: 100%;
  height: 4em;
  border-bottom: solid 1px #dfe3e8;
  ${props => props.isSelected ? `background-color: ${SHOPIFY_TEAL}; color: white;` : 'cursor: pointer;'}

  & button:first-child {
    ${props => props.isSelected ? 'border: 1px solid #5c6ac4;' : ''}
  }
`
const SceneRowContentContainer = styled.div`
  margin-left: 1em;
  margin-right: 1em;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const SceneRowButtonsContainer = styled.div`
  display: flex;
  font-size: 0.7em;
`

class ShopifyScenesDashboardNew extends Component {

  constructor (props) {
    super(props)
    this.state = {
      productsPickerVisible: false,
      collectionsPickerVisible: false,
      isModalOpen: false
    }
  }

  createNewScene = () => {
    const { app, startAddCollection } = this.props
    const templateInfo = getTemplateInfo(app.templateId)
    // console.log('app.slidesCnt', app.slidesCnt, 'templateInfo.maxSlides', templateInfo.maxSlides)
    if (app.slidesCnt < templateInfo.maxSlides) {
      // console.log('dispatch add slide')
      startAddCollection()
      // dispatch(addSlide(app))
    }
  }

  deleteSlide = (slideNum) => {
    const { app, dispatch, field, handleSceneChange } = this.props
    const templateInfo = getTemplateInfo(app.templateId)
    if (app.slidesCnt > 0 && slideNum < app.slidesCnt && (app.slidesCnt > templateInfo.minSlides)) {
      const activeSlideNum = _.get(field, 'location.showcaseNum')
      if (slideNum <= activeSlideNum) {
        const prevSlideNum = slideNum > 0 ? slideNum - 1 : 0
        handleSceneChange({ scene: scenes.SHOWCASE, showcaseNum: prevSlideNum, shareButtonsVisible: 0, productShown: null })
      }
      dispatch(delSlide(app, slideNum))
    }
  }

  goToSlideNum = (i) => {
    return () => {
      const { handleSceneChange } = this.props
      handleSceneChange({ scene: scenes.SHOWCASE, showcaseNum: i, shareButtonsVisible: 0, productShown: null })
    }
  }

  onBack = () => {
    const { field, location, dispatch } = this.props
    dispatch(changeEditorScene(location.sceneNum + field.backTo.sceneInc))
  }

  onNext = () => {
    const { field, location, dispatch } = this.props
    dispatch(changeEditorScene(location.sceneNum + field.nextTo.sceneInc))
  }

  onEditButtonClick = i => {
    return () => {
      console.log('onEditButtonClick', i)
      this.props.startAddCollection(i)
    }
  }

  renderDelButton = (i) => {
    const { app } = this.props
    const templateInfo = getTemplateInfo(app.templateId)
    if (app.slidesCnt > templateInfo.minSlides) {
      return (
        <Button size='slim' onClick={() => this.deleteSlide(i)}>
          <Icon source='delete' />
        </Button>
      )
    }
  }

  renderShowcaseRow = (showcase, i) => {
    const { field, addCollectionMode, editShowcaseIdx } = this.props
    let title = _.get(showcase, 'name')
    if (!title) {
      const names = []
      const p0 = _.get(showcase, ['products', 0, 'title'], '')
      const p1 = _.get(showcase, ['products', 1, 'title'], '')
      if (p0 !== '') names.push(p0)
      if (p1 !== '') names.push(p1)
      title = _.join(names, ' / ')
    }
    let isSelected = field.location.showcaseNum === i
    if (addCollectionMode) {
      isSelected = i === editShowcaseIdx
      console.log('i', i, 'editShowcaseIdx', editShowcaseIdx, 'isSelected', isSelected)
    }
    return (
      <SceneRow key={i} isSelected={isSelected} onClick={this.goToSlideNum(i)}>
        <SceneRowContentContainer>
          {title}
          <SceneRowButtonsContainer>
            {!addCollectionMode ? <Button id='previewButton' size='slim' onClick={this.goToSlideNum(i)}>Preview</Button> : null}
            <Button size='slim' onClick={this.onEditButtonClick(i)}>Edit</Button>
            {this.renderDelButton(i)}
          </SceneRowButtonsContainer>
        </SceneRowContentContainer>
      </SceneRow>
    )
  }

  renderScenesList () {
    const { app } = this.props
    const showcases = _.get(app, 'customFields.showcases', [])
    return _.map(showcases, this.renderShowcaseRow)
  }

  renderAddSceneButton () {
    const { app } = this.props
    const templateInfo = getTemplateInfo(app.templateId)
    if (app.slidesCnt < templateInfo.maxSlides) {
      return (
        <AddSceneButton onClick={this.createNewScene}>
          <IconPlus color='#606fc7' size='1.5em' />
          <Text color='#606fc7' containerStyle={'margin-left: 1em;'}>Add collection</Text>
        </AddSceneButton>
      )
    }
  }

  renderFooter () {
    const { addCollectionMode, field } = this.props
    if (!addCollectionMode) {
      return (
        <FooterContainer>
          <Button size='slim' onClick={this.onBack}>
            {_.get(field, 'backTo.title', 'Back')}
          </Button>
          <Button primary size='slim' onClick={this.onNext}>
            {_.get(field, 'nextTo.title', 'Back')}
          </Button>
        </FooterContainer>
      )
    }
  }

  render () {
    const { field } = this.props
    return (
      <Wrapper>
        <ScenesListWrapper>
          <Header>
            <h2 className='Polaris-Heading'>{field.title}</h2>
          </Header>
          {this.renderScenesList()}
          {/* {this.renderTestButtons()} */}
          {this.renderAddSceneButton()}
        </ScenesListWrapper>
        {this.renderFooter()}
      </Wrapper>
    )
  }
}

ShopifyScenesDashboardNew.defaultProps = {
  addCollectionMode: false
}

ShopifyScenesDashboardNew.propTypes = {
  field: PropTypes.object.isRequired,
  handleSceneChange: PropTypes.func.isRequired,
  app: PropTypes.object.isRequired,
  startAddCollection: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  addCollectionMode: PropTypes.bool,
  editShowcaseIdx: PropTypes.number
}

const mapStateToProps = state => ({
  location: state.location
})

export default connect(mapStateToProps)(ShopifyScenesDashboardNew)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyUI/ShopifyScenesDashboardNew.js